AOS.init();

window.addEventListener('load', function() {
  AOS.refresh();
});

// Set Gallery
let setGallery = (carousel) => {
	let gallery = document.querySelector('.gallery');
	if (typeof(gallery) != 'undefined' && gallery != null) {

		// Open image on click
		let galleryItems = gallery.querySelectorAll('.gallery__figure');
		let galleryPopUp = gallery.querySelector('.gallery__popup');
		let galleryContainer = gallery.querySelector('.gallery__popup__content');
		for(let i=0;i<galleryItems.length;i++) {
			let galleryItem = galleryItems[i];
			galleryItem.addEventListener('click', (e) => {
				setTimeout(()=>{  carousel.go( i ); },200);
				galleryPopUp.classList.add('active');
				setTimeout(() => {
					galleryPopUp.classList.add('visible');
				}, "500");				
			});
		}

		// Close on button or layout click
		let closeBtn = document.querySelector('.gallery__btn');
		closeBtn.addEventListener('click', () => { 
			galleryPopUp.classList.remove('visible');
			setTimeout(() => {
				galleryPopUp.classList.remove('active');
			}, "500");
		});

	}

}

// deactivateSiblings
function deactivateSiblings(els, activeClass) {
	for (const el of els) {
		el.classList.remove(activeClass);
	}
}

// Steps
let steps = document.querySelectorAll('.steps__item');
if (typeof(steps) != 'undefined' && steps != null) {

	for(let i=0;i<steps.length;i++) {
		let step = steps[i];
		let stepBtn = step.querySelector('.steps__btn');

		stepBtn.addEventListener('click', () => {
			if (step.classList.contains('active')) {
				step.classList.remove('active');
			} else {
				deactivateSiblings(steps, 'active');
				step.classList.add('active');
			}
		});
	}

}

// Accordion
let accordions = document.querySelectorAll('.accordion');

for (let i = 0; i < accordions.length; i++) {
	let accordion = accordions[i];
	let accordionBtn = accordion.querySelector('.accordion__header');
	accordionBtn.addEventListener('click', function() {
		if (accordion.classList.contains('active')) {
			accordion.classList.remove('active');
		} else {
			deactivateSiblings(accordions, 'active');
			accordion.classList.add('active');
		}
	});
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

let baseUrl = window.location.origin;

const body = document.body;
const navbarMenu = document.querySelector('.js-header__nav');
const burgerMenu = document.querySelector('.js-header__trigger');
const overlayMenu = document.querySelector('.header__overlay');
const menuItems = document.querySelectorAll('.menu-item:not(.menu-item-has-children) a');
const childrenedLink = document.querySelectorAll('.menu-item-has-children > a');

// Menu title
for(let i = 0; i < menuItems.length; i++ ) {
  let menuItem = menuItems[i];
	console.log(menuItem.innerHTML);
	menuItem.addEventListener('click', (e) => {
		if (e.target.href.includes('#showroom') || e.target.href.includes('#nos-valeurs') && document.body.classList.contains('home') ) {
			if (navbarMenu.classList.contains('active')) {
				toggleMenu();
			}
		};
	});
}

// insertAfter
function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Guess what it does
function removeHash() { 
  history.replaceState(null, null, ' ');
}

// Insert button after link with children
let injectAfter = (newNode, existingNode) => {
	existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Remove "active" class for menu-has-children siblings
let disableAllSiblings = (currIndex) => {
  for(let i = 0; i < childrenedLink.length; i++) {
		if(i != currIndex) {
			childrenedLink[i].parentNode.classList.remove('active');
		}
	}
}

// Add button to sub menu
function subMenu() {

  for(let i = 0; i < childrenedLink.length; i++) {
		let thisLink = childrenedLink[i];
		let btn = document.createElement('button');
		btn.classList.add('menu-toggler');
		injectAfter(btn, thisLink);
		btn.addEventListener('click', function() {
			let parent = btn.parentNode;
			disableAllSiblings(i);
			parent.classList.toggle('active');
		});
  }

}

subMenu();

// Toggle Menu Function
burgerMenu.addEventListener('click', toggleMenu);

function toggleMenu() {
	navbarMenu.classList.toggle('active');
	overlayMenu.classList.toggle('active');
	burgerMenu.classList.toggle('active');
	body.classList.toggle('active');
}

//DOM load
document.addEventListener("DOMContentLoaded", function(event) {

	let realisationsExists = document.querySelector('.splide-realisations');
	let testimoniesExists = document.querySelector('.splide-reviews');

	if (typeof(realisationsExists) != 'undefined' && realisationsExists != null) {
		// Carousel realisations
		let carouselrealisations = new Splide( realisationsExists, {
			type: 'fade',
			arrows: false,
			arrowPath: 'M 9.269531 1.023438 C 8.640625 1.660156 8.25 2.53125 8.25 3.503906 C 8.25 4.464844 8.640625 5.339844 9.269531 5.976562 L 23.300781 20.007812 L 9.269531 34.035156 C 8.644531 34.667969 8.253906 35.535156 8.253906 36.496094 C 8.253906 38.429688 9.824219 40 11.757812 40 C 12.722656 40 13.59375 39.617188 14.226562 38.984375 L 30.730469 22.480469 C 31.359375 21.847656 31.75 20.976562 31.75 20.007812 C 31.75 19.035156 31.359375 18.164062 30.730469 17.53125 L 14.226562 1.023438 C 13.585938 0.390625 12.714844 0 11.75 0 C 10.78125 0 9.910156 0.390625 9.269531 1.023438 Z M 9.269531 1.023438 ',
			pagination: true,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			clones: 0,
			breakpoints: {
				1024: {
					arrows: true,
				}
			}
		} );

		carouselrealisations.on( 'mounted', function () {
			setGallery(carouselrealisations);
		} );

		carouselrealisations.mount();

	}

	if (typeof(testimoniesExists) != 'undefined' && testimoniesExists != null) {
		// Carousel Testimonies
		let carouselTestimonies = new Splide( testimoniesExists, {
			type: 'loop',
			arrows: false,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					perPage: 3,
					gap: 40,
				},
			}
		} );

		carouselTestimonies.mount();

		let btnPrev = document.querySelector('.review__arrow--prev');
		let btnNext = document.querySelector('.review__arrow--next');

		//attach events to custom buttons
		btnNext.addEventListener('click', e => {
			carouselTestimonies.go('+1')
		})
	
		btnPrev.addEventListener('click', e => {
			carouselTestimonies.go('-1')
		})
		
	}

}); //end of DOM load

function collapseSubMenu() {
	navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
	navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
}

// Fixed Resize Screen Function
window.addEventListener('resize', () => {
	if (window.innerWidth > 992) {
		// If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}

		// If menu-item-child is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
	}
});

// SCROLL-RELATED FUNCTIONS

/* Animate on scroll */
let scrollOffset = 100;
let scrollElements = document.querySelectorAll(".js-scroll");

//initialize throttleTimer as false
let timerOne, timerTwo, timerThree = false;
 
let throttle = function(callback, throttleTimer, time) {

    //don't run the function while throttle timer is true
    if (throttleTimer) return;
     
    //first set throttle timer to true so the function doesn't run
    throttleTimer = true;
     
    setTimeout(function() {
        //call the callback function in the setTimeout and set the throttle timer to false after the indicated time has passed 
        callback();
        throttleTimer = false;
    }, time);
}

var elementInView = function(el, offset) {
  var offset = 0;
  var elementTop = el.getBoundingClientRect().top;
 
  return (
    elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - offset)
  );
};

var elementOutofView = function(el) {
  var elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

var displayScrollElement = function(element) {
  element.classList.add("scrolled");
};

var hideScrollElement = function(element) {
  element.classList.remove("scrolled");
};
 
var handleScrollAnimation = function() {
  scrollElements.forEach(function(el) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

/* STEPS BAR */

let stepsBarHeight= () => {
	if (typeof(document.querySelector(".steps__bar")) != 'undefined' && document.querySelector(".steps__bar") != null) {

	let stepButtons = document.querySelectorAll(".steps__btn");

	for(let i = 0; i < stepButtons.length; i++ ) {
		stepButtons[i].addEventListener("click", (e) => {
			let stepButton = stepButtons[i];
			stepButton.parentNode.classList.toggle('active');
		});
	}
	
	let stepBlocks = document.querySelectorAll(".steps__block");
	let stepBlocksLength = stepBlocks.length;

	let stepBar = document.querySelector(".steps__bar");
	let stepBarInner = document.querySelector(".steps__bar__inner");
	let stepBarHeight = stepBar.parentNode.offsetHeight - (stepBar.parentNode.offsetHeight / stepBlocksLength);
	let stepBarTop = stepBar.getBoundingClientRect().top;
	// let stepBarBottom = stepBarTop + stepBarHeight;

	stepBar.style.height = stepBarHeight + "px";

	let scrollStep = () => {
		let top  = window.pageYOffset || document.documentElement.scrollTop;
		let trigger = Math.round(top + window.innerHeight);
		let stepBarProgress = Math.round((window.pageYOffset + (window.innerHeight / 2) - stepBarTop));
		if (trigger > stepBarTop) {
			stepBarInner.style.height = stepBarProgress + "px";
		}
	}

	window.addEventListener('scroll', function() {
		throttle(scrollStep, false, 100);
	});

	};
}

stepsBarHeight();

let resizeSteps = debounce(function() {
	stepsBarHeight();
}, 250);

window.addEventListener("resize", resizeSteps);

/* Sticky menu */
let header = document.querySelector(".header");
let headerHeight = header.offsetHeight;
let flag = false;
let sticker = document.querySelector(".sticker");

let stickyMenu = () => {
	var posCurseur = window.scrollY;

	if(posCurseur < headerHeight){
		header.classList.remove('sticky');
		header.classList.remove('invisible');
		flag = false;
	} else if(posCurseur > headerHeight) {
		if (flag == false) {
			header.classList.add('invisible');
			setTimeout(() => {
				header.classList.add('sticky');
			}, 300);
			flag = true;
		} else {
			setTimeout(() => {
			header.classList.remove('invisible');
		}, 300);
		}
	}
}

/* Sticker */
let stickerMove = () => {
	if (typeof(sticker) != 'undefined' && sticker != null) {

		setTimeout(() => {
			sticker.classList.add('animated');
		}, 300);
		sticker.classList.remove('animated');

		if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
			sticker.classList.add("invisible");
			setTimeout(() => {
				sticker.classList.add('deleted');
			}, 300);
		} else {
			sticker.classList.remove('deleted');
			setTimeout(() => {
				sticker.classList.remove('invisible');
			}, 300);
		}
	};

}
 
window.addEventListener('scroll', function() {
	throttle(stickyMenu, timerOne, 250);
	throttle(stickerMove, timerTwo, 250);
  throttle(handleScrollAnimation, timerThree, 250);
})

let amazingForm = () => {

	let form = document.querySelector('.anah');
	let sections = document.querySelectorAll('.anah__section');
	let fields = document.querySelectorAll('.anah__field');
	let inf = document.querySelector("#inf + label");
	let sup = document.querySelector("#sup + label");
	let income = document.querySelector('span[data-name="your-income"] input');
	let result = document.querySelector('.anah__result');
	let sum;

	let changeIt = () => {
		inf.innerHTML = 'Inférieur à ' + '<span class="sum">' + sum + '</span>';
		sup.innerHTML = 'Supérieur à ' + '<span class="sum">' + sum + '</span>';
	}

	// Beginning of the Loopception //

	// Loop for blocks
	for (let y = 0; y < sections.length; y++) {

		let section = sections[y];
		let btn = section.querySelector('.btn');
		let innerFields = section.querySelectorAll('.anah__field');
		let innerFieldsLength = innerFields.length;

		if (typeof(btn) != 'undefined' && btn != null) {

			btn.dataset.counter = innerFieldsLength;
			let btnLink = btn.querySelector(".btn__link");

			btnLink.addEventListener("click", (e) => {
				if(!btn.classList.contains('is-disabled')) {
					e.preventDefault();
					// change height
						let height = sections[y + 1].querySelector(".anah__block").offsetHeight;
						form.style.maxHeight = height + "px";
					//
					setTimeout(() => {
						let scrollToTop = window.setInterval(function() {
							var pos = window.pageYOffset;
							if ( pos > 0 ) {
									window.scrollTo( 0, pos - 20 ); // how far to scroll on each step
							} else {
									window.clearInterval( scrollToTop );
							}
						}, 18);
					}, 500);
					sections[y].classList.add("done");
				}
			});
		}

	}

	// Loop for fields n'radios
	for (let i = 0; i < fields.length; i++) {

		// console.log(fields[i]);
		let radios = fields[i].querySelectorAll('input[type="radio"]');
		let checked = false;

			for (let j = 0; j < radios.length; j++) {
				let radio = radios[j];

				radio.addEventListener('change', (event) => {

					let btn = radio.parentNode.parentNode.querySelector('.btn');

					if (typeof(btn) != 'undefined' && btn != null) {

						let btnCounter = btn.getAttribute("data-counter");
					
						//count checked radios
						if (checked == false) {
							btn.dataset.counter = btnCounter - 1;
							checked = true;
						}

						//if all radios are checked, enable button on count
						if( btn.dataset.counter == 0 ) {
							btn.classList.remove('is-disabled');
						}

						// if inf-sub or classic
						if(radio.id == "inf") {
							result.innerHTML = "<strong>Félicitations</strong> d’après vos réponses vous êtes éligible aux aides de l’ANAH. Un de nos conseillers va prendre contact avec vous pour discuter de votre projet."
							income.defaultValue = document.querySelector("label[for=" + radio.id + "]").textContent;
						} else if (radio.id == "sup") {
							result.innerHTML = "D’après vos réponses, vous n’êtes pas éligibles aux aides de l’ANAH. Mais d’autres aides existent (crédit d’impôt), un de nos conseillers va vous appeler pour en discuter."
							income.defaultValue = document.querySelector("label[for=" + radio.id + "]").textContent;
						}

					}

					let check = i + 1;
					// console.log(check);
					let eq = document.getElementsByName("check-" + [check])[j];
					eq.checked = true;

					// radio sum
					if(radio.id == "one") {
						sum = "19 565 €";
						changeIt();
					} else if(radio.id == "two") {
						sum = "28 614 €";
						changeIt();
					}

				});
			}

		}

}

let resizeForm = debounce(function() {
	amazingForm();
}, 250);

window.addEventListener("resize", resizeForm);

amazingForm();

/* Smooth Scroll */
/* https://github.com/cferdinandi/smooth-scroll */
new SmoothScroll('a[href*="#"]:not(a[href*="#tarteaucitron"])', {
	speed: 1000,
	speedAsDuration: true,
	easing: 'easeInOutQuart'
});
